import * as Yup from "yup";
import YupPassword from "yup-password";

YupPassword(Yup);

const SimpleAuthFormSchema = () => {
  return Yup.object().shape({
    password: Yup.string()
      .min(6, "Hasło musi mieć co najmniej 6 znaków")
      .minNumbers(1, "Hasło musi mieć co najmniej 1 cyfrę")
      .required("Hasło jest wymagane"),
  });
};

export default SimpleAuthFormSchema;
